'use strict';
import { isiOs, isIE, isChrome, isFirefox, isSafari } from './plugins/browser-checks';

window.viewport = function() {
    let e = window,
        a = 'inner';

    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}

window.prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

jQuery(() => {
    // global functionality goes here
    const $html = $('html'),
        $body = $('body'),
        $masthead = $('header.masthead');

    $html.addClass('jsenabled');

    if(isiOs()) $html.addClass('browser-ios');
    if(isIE()) $html.addClass('browser-ie');
    if(isChrome()) $html.addClass('browser-chrome');
    if(isFirefox()) $html.addClass('browser-firefox');
    if(isSafari()) $html.addClass('browser-safari');

    // prevent disabled buttons to execute default actions
    $('.btn--disabled').on('click', function(e) {
        e.preventDefault();
    });

    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('.section__background-video').hide();
    }

    // load extra JS parts
    require('./modules/anchors-missing-title');
    require('./modules/dev-env');
    require('./modules/fancybox');
    require('./modules/gravity-forms');
    require('./modules/gtm-events');
    require('./modules/html-videos');
    require('./modules/insert-icons');
    require('./modules/lenis');
    require('./modules/sliders');
    require('./modules/tooltips');
    require('./modules/section-masks');
    require('./modules/expandable-items');
});
